export const sidebar = {
  reduce: "Collapse",
  dashboard: "Dashboard",
  sale: "Sales",
  quote: "Quotes",
  invoice: "Invoices",
  credit_note: "Credit Note",
  purchase: "Expenses",
  purchase_expenses: "Purchase Expenses",
  purchase_invoice: "Purchase Invoices",
  client: "Client",
  clients: "Clients",
  offers: "Offers",
  singature: "Singature",
  document: "Documents",

  suppliers: "Suppliers",
  config: "settings",
  utilisateur: "Users",
  singaturelist: "Signature List",
  projects: "Projects",
  absence: "My absences",
  mestemps: "My timesheet ",
  requestLeave: "Leave request",
  validetcra: "Timesheet Overview",

  // 📦 Packs
  pack: "Pack",
  pack_create: "Create a pack",

  users: "Users",
  role: "Roles",

  expense: "Expense",

  offer_create: "Create an offer",

  documents: "Documents",
};
